export default "__VITE_ASSET__3Rj3ifrw__"